<template>
  <div>
    <div class="page f-pr">

      <div class="btn-back" @click="goBackIndex">
        <img src="../assets/bar-map/btn-back.png" alt="" />
      </div>

      <div class="btn-rules" @click="showRules = !showRules">
        <img src="../assets/bar-map/btn-rules.png" alt="" />
      </div>

      <div class="btn-start"  v-if="!isBarActive()" @click="showFormPopup">
        <img src="../assets/bar-map/btn-start.png" alt="" />
      </div>

      <div class="drink-count" v-if="isBarActive()">
        <span class="drink-count-num">{{ actUserStoreClocks.length || 0 }} </span>
        <span class="drink-count-label">/ 3</span>
      </div>

      <!-- 图片层：只负责显示，不接收点击 -->
      <div
        v-for="bar in bars"
        :key="bar.key"
        class="bar-img"
        :class="`bar-img-${bar.key}`"
      >
        <img
          :src="require(`../assets/bar-map/${bar.key}.png`)"
          :alt="bar.name"
          :class="{ 'bar-inactive': !isBarActive() }"
        />
      </div>
      <!-- 点击层：透明div，接收点击事件 -->
      <div
        v-for="bar in bars"
        :key="'click-' + bar.key"
        class="bar-click"
        :class="`bar-click-${bar.key}`"
        @click.stop="openStoreDetail(bar)"
      ></div>

    </div>

    <!-- 輸入兌換碼彈窗 -->
    <van-overlay :show="showForm" z-index="999" @click="showForm = false">
      <div class="fcc-h redeem-overlay" style="height: 100vh; overflow: auto">
        <div class="f-pr redeem-con" @click.stop="">
          <img src="../assets/bar-map/redeem-bg.png" alt="" class="redeem-bg-img" />
          <div class="redeem-input-area">
            <input
              type="text"
              v-model="ticketNo"
              class="redeem-input"
              placeholder="請輸入 Please enter"
            />
          </div>
          <div class="redeem-btn-area" @click.stop="getBarHopping"></div>
          <div class="close-area"  @click.stop="showForm = false"></div>
          <div class="redeem-mfood fcc" @click="goToRedeemMfood()">
            <img src="../assets/bar-map/redeem-mfood.png" alt="" />
          </div>
          <div class="redeem-tikbee fcc" @click="goToRedeemTikbee()">
            <img src="../assets/bar-map/redeem-tikbee.png" alt="" />
          </div>
        </div>
      </div>
    </van-overlay>

    <!-- 參加規則彈窗 -->
    <van-overlay :show="showRules" z-index="999" :lock-scroll="false" @click="showRules = false">
      <div class="fcc-h rules-overlay" style="height: 100vh; overflow: auto">
        <div class="f-pr rules-con" @click.stop="">
          <img src="../assets/bar-map/rules-content.png" alt="" class="rules-img" />
          <div class="close-area-2"  @click.stop="showRules = false"></div>
          <div class="rule-mfood fcc" @click="goToRuleMfood()">
            <img src="../assets/bar-map/rule-mfood.png" alt="" />
          </div>
          <div class="rule-tikbee fcc" @click="goToRuleTikbee()">
            <img src="../assets/bar-map/rule-tikbee.png" alt="" />
          </div>
        </div>
      </div>
    </van-overlay>


    <van-overlay :show="showLoading">
      <div class="fcc-h" style="height: 100vh;">
        <van-loading size="24px" vertical color="#fff">Loading...</van-loading>
      </div>
    </van-overlay>

    <div style="position: fixed; left: 110%; top: 110%; width: 0; height: 0; overflow: hidden;">
      <audio id="audioID" ref="audio" class="aud">
        <source src="https://science.warnny.com/fulong/duang.mp3" type="audio/mp3" />
      </audio>
    </div>
  </div>
</template>

<script>
import { getBarHopping, login, recoverByTicketCode } from '@/api/api'
import { getOrCreateUserId } from '@/utils/auth'

export default {
  data() {
    return {
      showLoading: false,
      showRules: false,
      showForm: false,

      ticketNo: '',
      uid: '',
      userInfo: {
        barHoppingActive: 0
      },
      actUserStoreClocks: [],
      requesting: false,

      bars: [
        { key: 'arooma', name: 'AROOMA Coffee & Bar', storeId: 1, hours: '--', address: '--', intro: '--' },
        { key: 'blues', name: 'BLUES COCKTAIL BAR', storeId: 2, hours: '--', address: '--', intro: '--' },
        { key: 'bookand', name: 'Bik AND Pub', storeId: 3, hours: '--', address: '--', intro: '--' },
        { key: 'liber', name: 'COFFEE LIT ROASTER', storeId: 5, hours: '--', address: '--', intro: '--' },
        { key: 'epic', name: 'EPIC', storeId: 4, hours: '--', address: '--', intro: '--' },
        { key: 'mjcafe', name: '十六浦MJ咖啡館', storeId: 6, hours: '--', address: '--', intro: '--' },
        { key: 'momokawa', name: 'momokawa', storeId: 7, hours: '--', address: '--', intro: '--' },
        { key: 'toritori', name: 'TORI! TORI!', storeId: 9, hours: '--', address: '--', intro: '--' },
        { key: 'yami', name: 'yami', storeId: 10, hours: '--', address: '--', intro: '--' },
        { key: 'gallery', name: 'THE gallery 畫廊吧', storeId: 8, hours: '--', address: '--', intro: '--' },
      ]
    }
  },
  async mounted() {
    const userId = getOrCreateUserId()
    if (userId) {
      this.uid = userId
      this.login(userId)
    }
  },
  methods: {
    goBackIndex(){
      this.$router.push({ path: '/index' })
    },
    goToRuleMfood() {
      window.location.href = 'https://activity.h5-mfoodapp.com/#/group/store?id=202607091201161252376&isShare=true'
    },
    goToRuleTikbee() {
      window.location.href = 'https://m.tikbee.com/download/?id=1392354114253496062&type=1'
    },
    goToRedeemMfood() {
      window.location.href = 'https://activity.h5-mfoodapp.com/#/group/store?id=202607091201161252376&isShare=true'
    },
    goToRedeemTikbee() {
      window.location.href = 'https://m.tikbee.com/download/?id=1392354114253496062&type=1'
    },
    isBarActive() {
      return this.userInfo.barHoppingActive == 1
    },
    login(uid) {
      this.showLoading = true
      login({ username: uid }).then(res => {
        if (res.status != 200) {
          this.$toast(res.msg)
          this.showLoading = false
          return
        }
        window.localStorage.setItem('uid', res.data.userInfo.username)
        window.localStorage.setItem('token', res.data.token)
        this.uid = res.data.userInfo.username
        this.userInfo = res.data.userInfo
        this.actUserStoreClocks = res.data.userInfo.actUserStoreClocks || []
        this.showLoading = false
      })
    },
    showFormPopup() {
      if (this.userInfo.barHoppingActive == 1) {
        this.$toast('酒吧打卡已開啟\nBar hopping is already activated')
        return
      }
      this.ticketNo = ''
      this.showForm = true
    },
    async getBarHopping() {
      // this.$toast('活動暫未開啟\nActivity has not started yet')
        // return
      if (!this.ticketNo) {
        this.$toast('請輸入啟動碼\nPlease enter activation code')
        return
      }
      if (this.requesting) return
      this.requesting = true
      this.showLoading = true
      let res = await getBarHopping({
        ticketNo: this.ticketNo,
        userId: this.uid
      })

      if (res.status == 200) {
        // 首次激活成功
        this.showLoading = false
        this.requesting = false
        this.$toast('開啟成功\nStart Successfully')
        setTimeout(() => {
          this.showForm = false
          this.login(this.uid)
        }, 1500)
      } else {
        // 检查是否是"已使用"的错误，走恢复流程
        if (res.msg && res.msg.includes('CODE_ALREADY_USED')) {
          let recoverRes = await recoverByTicketCode({
            ticketNo: this.ticketNo
          })
          this.showLoading = false
          this.requesting = false
          if (recoverRes.status == 200) {
            // 切换到原始用户
            const originalUsername = recoverRes.data.userInfo.username
            localStorage.setItem('openId', originalUsername)
            localStorage.setItem('token', recoverRes.data.token)
            this.uid = originalUsername
            this.$toast('帳號恢復成功\nAccount recovered')
            setTimeout(() => {
              this.showForm = false
              // 恢复后必须重新login，确保前后端数据同步
              this.login(originalUsername)
            }, 1500)
          } else {
            this.$toast(recoverRes.msg || '恢復失敗')
          }
        } else {
          this.showLoading = false
          this.requesting = false
          this.$toast(res.msg)
        }
      }
    },
    openStoreDetail(bar) {
      if(!this.isBarActive()) return
        this.$router.push('/bar-store/' + bar.storeId)
    },
  }
}
</script>

<style scoped lang="less">
.page {
  display: block;
  min-height: 100vh;
  background: url(../assets/bar-map/bg-clean.png) no-repeat;
  background-size: 100% auto;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 1625px;
}

.btn-back {
  position: absolute;
  left: 26px;
  top: 24px;
  width: 121px;
  cursor: pointer;

  img {
    display: block;
    width: 100%;
  }

  &:active {
    opacity: 0.6;
  }
}

.btn-rules {
  position: absolute;
  right: 48px;
  top: 197px;
  width: 174px;
  cursor: pointer;

  img {
    display: block;
    width: 100%;
  }

  &:active {
    opacity: 0.6;
  }
}

.btn-start {
  position: absolute;
  left: 175px;
  bottom: 78px;
  cursor: pointer;
  z-index: 999;
  img {
    display: block;
    width: 400px;
    height: 100%;
  }
  &:active {
    opacity: 0.7;
  }
}

.drink-count {
  position: absolute;
  left: 50%;
  top: 1468px;
  transform: translateX(-50%);
  display: flex;
  align-items: baseline;
  z-index: 10;

  &-num {
    font-size: 58px;
    font-weight: 700;
    color: #e8be6a;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  }

  &-label {
    font-size: 32px;
    font-weight: 600;
    color: rgba(232, 190, 106, 0.6);
    margin-left: 6px;
  }
}

/* 图片层：纯展示，不接收点击，堆叠不影响点击 */
.bar-img {
  position: absolute;
  pointer-events: none;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .bar-inactive {
    filter: grayscale(100%);
    // opacity: 0.6;
  }

  &-arooma { left: 283px; top: 289px; width: 414px; height: 266px;  }
  &-blues { left: 48px; top: 304px; width: 388px; height: 385px; }
  &-bookand { left: 234px; top: 492px; width: 401px; height: 310px; }
  &-liber { left: -21px; top: 613px; width: 408px; height: 334px; }
  &-epic { left: 422px; top: 542px; width: 412px; height: 378px; }
  &-mjcafe { left: 174px; top: 667px; width: 400px; height: 392px; }
  &-momokawa { left: 366px; top: 872px; width: 410px; height: 303px; }
  &-toritori { left: 104px; top: 1065px; width: 422px; height: 258px; }
  &-yami { left: 299px; top: 1122px; width: 438px; height: 325px; }
  &-gallery { left: -96px; top: 885px; width: 424px; height: 321px; }
}

/* 点击层：透明div，浮在图片之上接收点击 */
.bar-click {
  position: absolute;
  cursor: pointer;
  z-index: 5;
  // background: rgba(255,0,0,0.3);

  &:active {
    opacity: 0.6;
  }

  &-arooma { left: 390px; top: 280px; width: 270px; height: 200px; }
  &-blues { left: 60px; top: 340px; width: 230px; height: 280px; }
  &-bookand { left: 380px; top: 500px; width: 200px; height: 230px; }
  &-liber { left: 30px; top: 640px; width: 200px; height: 250px; }
  &-epic { left: 500px; top: 740px; width: 230px; height: 150px; }
  &-mjcafe { left: 260px; top: 740px; width: 220px; height: 270px; }
  &-momokawa { left: 500px; top: 920px; width: 220px; height: 220px; }
  &-toritori { left: 220px; top: 1100px; width: 200px; height: 220px; }
  &-yami { left: 450px; top: 1160px; width: 270px; height: 240px; }
  &-gallery { left: 10px; top: 930px; width: 190px; height: 240px; }
}

/* ===== 兌換碼彈窗 ===== */
.redeem-overlay {
  background: rgba(0, 0, 0, 0.5);
}

.redeem-con {
  width: 670px;
}

.redeem-bg-img {
  display: block;
  width: 100%;
  border-radius: 20px;
}

.redeem-input-area {
  position: absolute;
  left: 150px;
  top: 200px;
  width: 373px;
  height: 68px;
}

.redeem-input {
  width: 100%;
  height: 100%;
  border: 2px solid rgba(100, 180, 160, 0.5);
  border-radius: 8px;
  text-align: center;
  font-size: 28px;
  color: #3d2b1f;
  background: rgba(255, 255, 255, 0.85);
  outline: none;
  padding: 0 16px;
  box-sizing: border-box;

  &::placeholder {
    color: rgba(61, 43, 31, 0.4);
  }
}

.redeem-btn-area {
  position: absolute;
  left: 250px;
  top: 300px;
  width: 168px;
  height: 90px;
  cursor: pointer;

  &:active {
    opacity: 0.7;
  }
}

.close-area {
  position: absolute;
  right: 30px;
  bottom: 25px;
  width: 128px;
  height: 90px;
  cursor: pointer;

  &:active {
    opacity: 0.7;
  }
}

.close-area-2 {
  position: absolute;
  right: 30px;
  bottom: 50px;
  width: 128px;
  height: 80px;
  cursor: pointer;

  &:active {
    opacity: 0.7;
  }
}

.x-btn-redeem {
  position: absolute;
  right: -50px;
  top: -20px;
  cursor: pointer;

  img {
    width: 80px;
    height: 80px;
  }
}

/* ===== 規則彈窗 ===== */
.rules-overlay {
  background: rgba(0, 0, 0, 0.5);
}

.rules-con {
  width: 670px;
  position: relative;
}

.rules-img {
  display: block;
  width: 100%;
  border-radius: 20px;
}

.x-btn-rules {
  position: absolute;
  right: -50px;
  top: -20px;
  cursor: pointer;

  img {
    width: 80px;
    height: 80px;
  }
}

.rule-mfood {
  position: absolute;
  left: 130px;
  top: 230px;
  cursor: pointer;

  img {
    width: 178px;
    height: 210px;
  }
}

.rule-tikbee {
  position: absolute;
  right: 130px;
  top: 230px;
  cursor: pointer;

  img {
    width: 178px;
    height: 210px;
  }
}

.redeem-mfood {
  position: absolute;
  left: 130px;
  top: 408px;
  cursor: pointer;

  img {
    width: 178px;
    height: 210px;
  }
}

.redeem-tikbee {
  position: absolute;
  right: 130px;
  top: 408px;
  cursor: pointer;

  img {
    width: 178px;
    height: 210px;
  }
}

</style>
